// The Firebase Admin SDK to access the Firebase Realtime Database.
// import { firebaseApp } from "../services/firebase";
const now = () => {
  return new Date();
  // return firebaseApp.firebase.firestore.FieldValue.serverTimestamp();
};

export default now;
